export default function NotFound() {
  return (
    <div className="min-h-screen flex justify-center text-white items-center space-x-2">
      <span className="text-xl">404</span>
      <span className="text-3xl font-thin">|</span>
      <span className="text-xl">Not Found</span>
    </div>
  )
}